/**
 * Sidebar backdrop overlay for mobile.
 * Extracted from Dashboard.js so it can be tested in isolation without
 * Dashboard's heavy transitive service imports.
 */
export default function SidebarOverlay({ open, onClose, className }) {
  if (!open) return null;
  return (
    <div
      className={className}
      data-testid="sidebar-overlay"
      onClick={() => {
        onClose();
        localStorage.setItem("isMenuOpen", false);
      }}
    />
  );
}
